import { useSelector } from 'react-redux';

import { selectChangedNodesState } from '@lib/core/quizzes/selectors/changedNodes';

export const useChangedNodes = () => {
  return {
    changedNodes: useSelector(selectChangedNodesState),
  };
};
